import React, { useState, useRef, useCallback, useEffect } from 'react';
import { useRecoilState } from 'recoil';
import { activeRestaurantState } from '../../../../recoil';
import { appIcon } from '../../../../const';
import { ApiHelpers, imageToBase64 } from '../../../../helpers';
import QRCode from 'qrcode.react';
import { Spin } from 'antd';

const QRCodeCustomPreview = (props) => {
    const { value, customization, tableIndex = '10', isStaticPreview } = props;
    const [generatedQR, setGeneratedQR] = useState('');
    const [isLoading, setIsLoading] = useState(true);
    const [activeRestaurant, setActiveRestaurant] = useRecoilState(activeRestaurantState);
    const [logoBase64, setLogoBase64] = useState(null);
    const [bgImageBase64, setBgImageBase64] = useState(null);
    const isSelfService = activeRestaurant.sysRestaurantType === 'SelfService';
    
    // Load images as base64
    useEffect(() => {
        const loadImages = async () => {
            try {
                // Load QR code logo
                const logoUrl = activeRestaurant.subscriptionPlan !== 'Free' && activeRestaurant.logoPath
                    ? ApiHelpers.getImageLink(activeRestaurant.logoPath)
                    : appIcon;
                const logoData = await imageToBase64(logoUrl);
                setLogoBase64(logoData);
                
                // Load background image if exists
                if (customization.qrImagePath) {
                    const bgData = await imageToBase64(ApiHelpers.getImageLink(customization.qrImagePath));
                    setBgImageBase64(bgData);
                }
                
                setIsLoading(false);
            } catch (error) {
                console.error('Error loading images:', error);
                // Fallback to appIcon if loading fails
                setLogoBase64(appIcon);
                setIsLoading(false);
            }
        };
        
        if (customization && activeRestaurant) {
            loadImages();
        }
    }, [customization, activeRestaurant]);
    
    const QRCodeMarkup = logoBase64 ? (
        <QRCode
            value={value}
            size={isStaticPreview ? 190 : 780}
            level="Q"
            fgColor="#292333"
            renderAs="canvas"
            imageSettings={{
                src: logoBase64,  // Use base64 data URL
                width: isStaticPreview ? 50 : 200,
                height: isStaticPreview ? 50 : 200,
                excavate: true,
            }}
        />
    ) : null;

    return isLoading ? (
        <Spin />
    ) : (
        <div
            className={'customized-QR-container' + (isStaticPreview ? ' preview' : '')}
            style={{
                backgroundColor: customization.backgroundColour,
                backgroundImage: bgImageBase64 ? `url(${bgImageBase64})` : 'none',
            }}>
            {customization.qrImagePath ? (
                <div className="customized-QR-bg-layer" style={{ backgroundColor: customization.backgroundColour + '60' }}></div>
            ) : null}

            <div className={'customized-QR-content' + (value ? ' qr-value' : '')}></div>
            {!isStaticPreview || value ? <div className="customized-QR-value">{QRCodeMarkup}</div> : null}
            <div className={'customized-QR-text text-title' + (!customization.showAllActions ? ' text-short' : '')}>
                vezi{' '}
                <span
                    className="customized-QR-text text-highlight"
                    style={{
                        color:
                            customization.backgroundColour !== '#FFFFFF' && customization.backgroundColour !== '#F6EFD6'
                                ? customization.backgroundColour
                                : '#C32E32',
                    }}>
                    meniul
                </span>{' '}
                {customization.showAllActions ? 'și cheamă ospătarul' : null}
            </div>
            <div className="customized-QR-logo">
                <img src={logoBase64} className="customized-QR-logo" alt="Logo" />
            </div>
            {customization.showAllActions ? <div className="customized-QR-text text-subTitle">cere nota | acordă feedback</div> : null}
            <div className="customized-QR-text text-bottom">
                <span className="customized-QR-text text-bottom-highlight">{tableIndex}</span> {activeRestaurant.title}
            </div>
        </div>
    );
};

export default QRCodeCustomPreview;